import { render, staticRenderFns } from "./Pendding.vue?vue&type=template&id=647c5151"
import script from "./Pendding.vue?vue&type=script&lang=js"
export * from "./Pendding.vue?vue&type=script&lang=js"
import style0 from "./Pendding.vue?vue&type=style&index=0&id=647c5151&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports